import { DonorStatus } from 'gql/types';

export const getEffectiveRetiredDate = (
  retiredDate?: string | Date | null,
  status?: DonorStatus | null,
  donorStatusUpdatedAt?: string | Date | null
): string | Date | null | undefined => {
  if (retiredDate) {
    return retiredDate;
  }

  if (status === DonorStatus.Retired) {
    return donorStatusUpdatedAt;
  }

  return undefined;
};
